import React from 'react'

import back from './img/stretches/back.webp'
import legs from './img/stretches/legs.webp'
import neck from './img/stretches/neck.webp'
import shoulders from './img/stretches/shoulders.webp'
import wrists from './img/stretches/wrists.webp'
import { useTranslation } from '../../lib/i18n'

const IMAGES = { neck, shoulders, back, wrists, legs }

const AREAS = ['neck', 'shoulders', 'back', 'wrists', 'legs']

const paragraphs = (items) => (
    <>
        {items.map((text, i) => <p key={i}>{text}</p>)}
    </>
)

export default function useStretchConfig() {
    const { t } = useTranslation(undefined, { keyPrefix: 'stretches' })

    return AREAS.map((area) => ({
        title: t(`${area}.title`),
        image: IMAGES[area],
        description: paragraphs(t(`${area}.description`, { returnObjects: true })),
        readMore: (
            <>
                <h3>{t(`${area}.readMoreHeading`)}</h3>
                {paragraphs(t(`${area}.readMore`, { returnObjects: true }))}
            </>
        ),
    }))
}
